import React, { useState, useEffect } from 'react';
import './SurgeonProfile.css';
import SurgeonPhoto from './surgeon6.webp';
import ClinicLogo from './clinic-logo.webp';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';

function SurgeonProfile() {
  const [offsetY, setOffsetY] = useState(0);
  const maxOffsetY = 800;  // Maximum offset for background to stop moving
  const navigate = useNavigate(); // Initialize useNavigate
  const { language } = useLanguage();
  const t = translations[language];

  useEffect(() => {
    const handleScroll = () => {
      const newOffsetY = Math.min(window.pageYOffset, maxOffsetY);  // Cap the offsetY at maxOffsetY
      setOffsetY(newOffsetY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [maxOffsetY]);

  const backgroundStyle = {
    transform: `translateY(${offsetY * 0.3}px)`,  // Adjust the speed of the background movement here
  };

  return (
    <div className="SurgeonProfile">
      <div className="SurgeonProfile-background" style={backgroundStyle} />
      <div className="SurgeonProfile-content">
        <div className="SurgeonProfile-info">
          <img src={ClinicLogo} alt="Clinic Logo" className="Clinic-logo" loading="lazy" />
          <p className="Surgeon-description">
            {t.surgeonDescription}
          </p>
        </div>
        <div className="SurgeonProfile-image">
          <img src={SurgeonPhoto} alt="Surgeon" />
        </div>
        <div className="button-about">
          <button className="button-about-btn" onClick={() => navigate('/about')}>{t.moreBtn}</button>
        </div>
      </div>
    </div>
  );
}

export default SurgeonProfile;
